import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiService} from "@core/shared/services/api.service";
import {OfferLocationTransport} from '@core/shared/models/offer/offer-location/offer-location-transport';

@Injectable({
    providedIn: 'root'
})
export class OfferLocationTransportService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {}

    public getOfferItemsAPI(offerId: number, params?: string[]): Observable<OfferLocationTransport[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/offers/${offerId}/locations/transports`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<OfferLocationTransport[]>(url, {headers: headers});
    }
}
